import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export type IStyledGhostProductProps = {
  textColor: string;
  suffix: string;
};

export const StyledGhostProduct = styled.div<IStyledGhostProductProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center !important;
  margin-right: 16px;
  flex: 1;

  &:last-child {
    margin-right: 0;
  }

  .image-container {
    display: flex;
    justify-content: center;
    overflow: hidden;
    align-items: center;
    height: 36px;
    width: 36px;

    .image {
      max-width: 36px;
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  .quantity {
    text-align: ${({ suffix }) => (suffix ? 'center' : 'left')};
    font-size: 14px;
    font-style: normal;
    font-weight: 950;
    line-height: normal;
    font-family: inherit;
    color: ${({ textColor }) => textColor};
  }

  @media only screen and (min-width: ${breakpoints.desktop}) {
    margin-right: 18px;

    .image-container {
      height: 42px;
      width: 42px;

      .image {
        max-width: 42px;
      }
    }

    .quantity {
      font-size: 16px;
    }
  }
`;
